import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import { resolveMergeFields } from "@/use/formatter";

interface Props {
  text: string;
  lenderName: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EstablishMembership',
  props: {
    text: {},
    lenderName: {}
  },
  setup(__props: any) {

const props = __props;

const resolvedText = computed(() => {
  return resolveMergeFields(props.text, {
    lenderName: props.lenderName,
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", null, _toDisplayString(resolvedText.value), 1))
}
}

})